/**
 * UserSettings — legacy /user-settings page (Old Pages dropdown).
 *
 * 2026-07-09 (Sabeeh): the Documentation tab was removed — its viewer
 * (DocumentationViewerTab, now deleted) listed 51 markdown files under
 * /docs/*.md that no longer deploy (see public/docs/README.md), so every
 * doc 404'd. Real settings live on the new /settings page; this page now
 * just points there.
 */
import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { BrandProvider } from '@/contexts/BrandContext'
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Settings } from 'lucide-react'

export default function UserSettings() {
  return (
    <BrandProvider>
      <NewAppLayout>
        <div className="max-w-7xl mx-auto space-y-6">
          {/* Header */}
          <div className="flex items-center gap-3 mb-8">
            <Settings className="h-8 w-8 text-primary" />
            <div>
              <h1 className="text-3xl font-bold text-foreground">Settings (legacy)</h1>
              <p className="text-muted-foreground">This page has moved</p>
            </div>
          </div>

          <Card>
            <CardHeader>
              <CardTitle>Settings moved</CardTitle>
            </CardHeader>
            <CardContent className="space-y-2">
              <p className="text-sm text-muted-foreground">
                Profile, security and internal documentation now live on the new{' '}
                <a href="/settings" className="text-primary hover:underline font-medium">
                  Settings
                </a>{' '}
                page.
              </p>
            </CardContent>
          </Card>
        </div>
      </NewAppLayout>
    </BrandProvider>
  )
}
